import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@core-ui/Components/ui/button.tsx';
import { Globe } from 'lucide-react';

const LanguageToggle: React.FC = () => {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);

  useEffect(() => {
    setCurrentLang(i18n.language);
  }, [i18n.language]);

  const toggleLanguage = (): void => {
    const newLang = currentLang.startsWith('en') ? 'es' : 'en';
    void i18n.changeLanguage(newLang);
    localStorage.setItem('i18nextLng', newLang);
    setCurrentLang(newLang);
  };

  const label = currentLang.startsWith('en') ? 'EN' : 'ES';

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-1 px-3 py-1.5 rounded-md border border-border bg-muted/30 text-sm font-medium text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
      data-qa-id="language-button"
    >
      <Globe className="size-4" />
      <span className="tracking-wide hidden md:block">{label}</span>
    </Button>
  );
};

export default LanguageToggle;
